<template >
  <div id="animation10interface">
    <lottie
      :options="defaultOptions"
      :autoplay="true"
      :lottiespeed="0.1"
      :loop="false"
      :height="180"
      :width="260"
      v-on:animCreated="handleAnimation"
    />
  
  </div> 
</template>

<style scoped>
.animation10interface {
  width:100%;
  height:100%;
  display:block;
  overflow: hidden;
  transform: translate3d(0,0,0);
  text-align: center;
  opacity: 1;
}
.text-color {
  color: #fff !important;
}
</style>

<script>
// import Lottie from "./lottie.vue";
import Lottie from "vue-lottie";
import * as animationData from "./../assets/mockups/map.json";

export default {
  name: "Animation9",
  components: {
    lottie: Lottie
  },
  data: () => ({
    defaultOptions: { animationData: animationData.default },
  }),
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
      
    },
  }
};
</script>